import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import { loadTenantConfig } from "config/tenantConfig";
import { injectTheme } from "config/themeInjector";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Multi-tenancy: ask "whose site is this?" before first paint so the page
// renders in the right tenant's branding. loadTenantConfig never throws and
// times out fast — worst case the built-in Iter look renders, as today.
const boot = async () => {
  injectTheme(await loadTenantConfig());
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
};
boot();

reportWebVitals();
